import React from "react";

import Icon from "@material-ui/core/Icon";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Typography from "@material-ui/core/Typography";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";

interface Props {}

function HelpPage(props: Props) {
  // TODO Can we use secondary text reasonably?
  // TODO language property depending on language settings?
  return (
    <>
      <Typography variant="h5" gutterBottom>
        Help
      </Typography>
      <List>
        <ListItem
          button
          component="a"
          href={`../doc/help_en.pdf`}
          target="_blank"
        >
          <ListItemIcon>
            <Icon>
              <FontAwesomeIcon icon={faFilePdf} />
            </Icon>
          </ListItemIcon>
          <ListItemText primary="Documentation" />
        </ListItem>
        <ListItem
          button
          component="a"
          href={`../doc/livedata_help.pdf`}
          target="_blank"
        >
          <ListItemIcon>
            <Icon>
              <FontAwesomeIcon icon={faFilePdf} />
            </Icon>
          </ListItemIcon>
          <ListItemText primary="LiveData help" />
        </ListItem>
        <ListItem
          button
          component="a"
          href={`../doc/admin_help_en.pdf`}
          target="_blank"
        >
          <ListItemIcon>
            <Icon>
              <FontAwesomeIcon icon={faFilePdf} />
            </Icon>
          </ListItemIcon>
          <ListItemText primary="Administrator manual" />
        </ListItem>
        <ListItem
          button
          component="a"
          href={`../doc/extension_help.pdf`}
          target="_blank"
        >
          <ListItemIcon>
            <Icon>
              <FontAwesomeIcon icon={faFilePdf} />
            </Icon>
          </ListItemIcon>
          <ListItemText primary="Extension manual" />
        </ListItem>
        <ListItem
          button
          component="a"
          href={`../doc/basicexport_help.pdf`}
          target="_blank"
        >
          <ListItemIcon>
            <Icon>
              <FontAwesomeIcon icon={faFilePdf} />
            </Icon>
          </ListItemIcon>
          <ListItemText primary="Help (Generic Export)" />
        </ListItem>
      </List>
      {/* TODO <AboutInfo /> or <ServerInfo /> */}
    </>
  );
}

export default HelpPage;
